import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { getAdminMe, type AdminMeResponse } from "@/api/cle-api";

export const adminMeQueryKey = ["cle-api", "auth", "me"] as const;

export const useAdminMe = (): UseQueryResult<AdminMeResponse, Error> =>
  useQuery({
    queryKey: adminMeQueryKey,
    queryFn: getAdminMe,
  });
